import { ThunkDispatch } from "redux-thunk";

import { set } from "@redux/modules/value/scrollLock/scrollLock";
import { $ScrollLockModuleName } from "@redux/modules/value/scrollLock/scrollLock.types";
import { IState, TExtraThunkArgs, TValueAction } from "@redux/store.types";
import { getValueState } from "@redux/utils";

const addDiscriminator =
    (discriminator: string) =>
    async (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: () => IState,
    ) => {
        const currentlyLockedDiscriminators =
            getValueState(getState(), $ScrollLockModuleName)
                ?.lockedDiscriminators ?? [];

        if (currentlyLockedDiscriminators.some(d => d === discriminator)) {
            return currentlyLockedDiscriminators;
        }

        const {
            payload: { lockedDiscriminators },
        } = dispatch(
            set({
                lockedDiscriminators: [
                    ...currentlyLockedDiscriminators,
                    discriminator,
                ],
            }),
        );

        return lockedDiscriminators;
    };

const removeDiscriminator =
    (discriminator: string) =>
    async (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: () => IState,
    ) => {
        const currentlyLockedDiscriminators =
            getValueState(getState(), $ScrollLockModuleName)
                ?.lockedDiscriminators ?? [];

        if (!currentlyLockedDiscriminators.includes(discriminator)) {
            return currentlyLockedDiscriminators;
        }

        const {
            payload: { lockedDiscriminators },
        } = dispatch(
            set({
                lockedDiscriminators: currentlyLockedDiscriminators.filter(
                    d => d !== discriminator,
                ),
            }),
        );

        return lockedDiscriminators;
    };

export { addDiscriminator, removeDiscriminator };
